/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap'
import { BrowserRouter as Router } from 'react-router-dom'
import { defaultModules } from '@pnotify/core'
import CacheBuster from 'react-cache-buster'
import * as PNotifyBootstrap4 from '@pnotify/bootstrap4'
import { useTranslation } from 'react-i18next'
import packageJson from '../package.json'
import { JWTProvider } from './contexts/JWTContext'
import { WebSocketProvider } from './contexts/WebSocketContext'
import { routes } from './routes/index'
import { renderRoutes } from './routes'
import { BASENAME, CONFIG } from './config/constant'

import '@pnotify/core/dist/BrightTheme.css'
import '@pnotify/core/dist/PNotify.css'
import '@pnotify/bootstrap4/dist/PNotifyBootstrap4.css'
import '@pnotify/mobile/dist/PNotifyMobile.css'
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { emptyLocalStorage } from './utils/localStorage'
import { isBo } from './utils/CommonMethods'
import { useIdleManager } from './utils/useIdleTimer'
import { useCountdown } from './utils/useCountdown'
import useGlobalShortcut from './hooks/ShortcutProvider'
import ModalSearchGlobal from './components/Modal/ModalGlobalSearch'

defaultModules.set(PNotifyBootstrap4, {})
export const disableConsole = () => {
  const noop = () => {} // Create a no-op function
  // Override console.log with a no-op function
  // eslint-disable-next-line no-global-assign
  console = {
    ...console,
    log: noop,
  }
}
function App() {
  const { t } = useTranslation()
  const [openModal, setOpenModal] = useState(false)
  const [openSearchGlobalModal, setOpenSearchGlobalModal] = useState(false)
  const isLeaderRef = useRef(false)

  const logout = () => {
    let urlRedirect = '/auth/signin'
    const isSupAdmin =
      window.localStorage.getItem('super_admin') == 'super_admin'
    if (isBo() || isSupAdmin) {
      urlRedirect = '/bo/auth/signin'
    }
    window.location.assign(`${window.location.origin + urlRedirect}`)
    emptyLocalStorage()
  }

  const isUserAuthenticated = () => {
    const userId = localStorage.getItem('user_id')
    const token = localStorage.getItem('CPI_ACCESS_TOKEN')
    return !!(userId || token)
  }

  const handleIdle = useCallback(() => {
    if (!isUserAuthenticated()) return
    isLeaderRef.current = true
    setOpenModal(true)
  }, [])

  const handleActive = useCallback(() => {
    isLeaderRef.current = false
    setOpenModal(false)
  }, [])

  const setRemoteTickRef = useRef(null)

  const handleTick = useCallback((remaining) => {
    isLeaderRef.current = false
    setOpenModal(true)
    setRemoteTickRef.current?.(remaining)
  }, [])

  const isProduction = process.env.NODE_ENV === 'production'

  const systemLanguage = navigator.language || navigator.userLanguage

  const handleForcedLogout = useCallback(() => {
    logout()
  }, [logout])

  const { broadcastStay, broadcastLogout, broadcastTick } = useIdleManager({
    idleTime: CONFIG.idleTimer * 60,
    onIdle: handleIdle,
    onActive: handleActive,
    onLogout: handleForcedLogout,
    onTick: handleTick,
  })

  const handleLogout = useCallback(() => {
    broadcastLogout()
    logout()
  }, [broadcastLogout, logout])

  const { remaining, setRemoteTick } = useCountdown({
    seconds: CONFIG.remainingTime,
    active: openModal,
    isLeader: isLeaderRef.current,
    onTick: broadcastTick,
    onComplete: handleLogout,
  })

  setRemoteTickRef.current = setRemoteTick

  const handleStay = useCallback(() => {
    isLeaderRef.current = false
    setOpenModal(false)
    broadcastStay()
  }, [broadcastStay])

  if (process.env.NODE_ENV !== 'development') disableConsole()

  useGlobalShortcut(() => {
    setOpenSearchGlobalModal(true)
  })

  return (
    // <React.StrictMode>
    <CacheBuster
      currentVersion={packageJson.version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<Spinner />}
    >
      <Router basename={BASENAME}>
        <JWTProvider>
          <WebSocketProvider>
            {renderRoutes(routes)}
            <Modal show={openModal}>
              <Modal.Header>
                <Modal.Title>{t('idleModal.title')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{t('idleModal.expiration')}</p>
                <p>{t('idleModal.question')}</p>
                <p>{t('idleModal.remaining', { remainingTime: remaining })}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={handleStay}
                  disabled={remaining === (0 || CONFIG.remainingTime)}
                >
                  {t('idleModal.button', { remainingTime: remaining })}
                </Button>
              </Modal.Footer>
            </Modal>
            {openSearchGlobalModal && (
              <ModalSearchGlobal
                open={openSearchGlobalModal}
                setOpen={setOpenSearchGlobalModal}
              />
            )}
          </WebSocketProvider>
        </JWTProvider>
      </Router>
    </CacheBuster>
    // </React.StrictMode>
  )
}

export default App

